import React, { useContext } from "react";
import { Divider } from "@mui/material";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { LoginViewContext } from "components/ForgotPswSendEmail.page";
import LoginIcon from "images/loginIcon.png";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { Grid, MobileStepper } from "@mui/material";
import LoadingScreen from "components/common/LoadingScreen";
import LockPromptDialog from "components/common/LockPromptDialog";
import { useStyles } from "../login/Login.page.style";
import ForgotpswEmailComponent from "./ForgotpswEmailComponent";

const LoginPC = () => {
	const {
		register,
		isLoading,
		theme,
		backgroundImgList,
		noticeHeightPx,
		iptNotice,
		inforHeightPx,
		usefulInfo,
		activeBackgroundIndex,
		logoLink,
		handleSubmit,
		onSubmit,
		control,
		errors,
		showLockTip,
		setShowLockTip,
		lockTipContent,
	} = useContext(LoginViewContext);

	const classes = useStyles();
	return (
		<div style={{ height: "100vh" }}>
			<LoadingScreen open={isLoading} />
			<StyledEngineProvider injectFirst>
				<ThemeProvider theme={theme}>
					<Grid container className={classes.fullHeight} flexWrap={"nowrap"}>
						<Grid item style={{ width: "65%" }} className={`${classes.leftWrapper} ${classes.fullHeight}`}>
							{Array.isArray(backgroundImgList) &&
								backgroundImgList.map((item, index) => {
									return (
										<img
											src={item.icon}
											key={index}
											alt={index}
											className={`${classes.backgroundImageClass} ${
												index === activeBackgroundIndex
													? classes.animInItem
													: classes.animExitItem
											}`}
										/>
									);
								})}
							<Grid container justifyContent={"center"} className={`${classes.fullHeight}`}>
								<Grid item container direction={"column"}>
									<Paper className={classes.InfoWrapper} style={{ height: noticeHeightPx }}>
										<Typography color={"primary"} className={classes.titleFont}>
											IMPORTANT NOTICE
										</Typography>
										<Divider className={classes.InfoDivider} />
										<div className={classes.InfoContainer}>
											{Array.isArray(iptNotice) &&
												iptNotice.length > 0 &&
												iptNotice.map((item, index) => (
													<div
														key={index}
														dangerouslySetInnerHTML={{ __html: item.content }}
													></div>
												))}
										</div>
									</Paper>
									<Paper className={classes.InfoWrapper} style={{ height: inforHeightPx }}>
										<Typography color={"primary"} className={classes.titleFont}>
											USEFUL INFORMATION
										</Typography>
										<Divider className={classes.InfoDivider} />
										<div className={classes.InfoContainer}>
											{Array.isArray(usefulInfo) &&
												usefulInfo.length > 0 &&
												usefulInfo.map((item, index) => (
													<div
														key={index}
														dangerouslySetInnerHTML={{ __html: item.content }}
													></div>
												))}
										</div>
									</Paper>
									<MobileStepper
										classes={{
											root: classes.stepperRoot,
											dot: classes.stepperDotRoot,
											dotActive: classes.dotActiveRoot,
										}}
										steps={backgroundImgList.length}
										activeStep={activeBackgroundIndex}
									/>
								</Grid>
							</Grid>
						</Grid>
						<Grid item className={`${classes.rightWrapper} ${classes.fullHeight}`}>
							<Grid container>
								<a href={logoLink} target={"_blank"}>
									<img src={LoginIcon} alt={"icon"} className={classes.loginIcon} />
								</a>
							</Grid>
							<Grid container className={classes.iconDivider}></Grid>
							<ForgotpswEmailComponent
								register={register}
								handleSubmit={handleSubmit}
								onSubmit={onSubmit}
								control={control}
								errors={errors}
							/>
						</Grid>
					</Grid>
				</ThemeProvider>
			</StyledEngineProvider>
			<LockPromptDialog open={showLockTip} onClose={() => setShowLockTip(false)} content={lockTipContent} />
		</div>
	);
};

export default LoginPC;
